/**
 *  Module to display a zoom view with the large product imagery
 */

const Zoom = function(app) {

  const _ = require('lodash');
  /**
   *  Private Properties/Methods
   */
  const configure = app.configure,
    $ = require('jquery'),
    $container = app.$container;
  let zoomComponent,
    zoomDialog,
    imageView = 'Front',
    dialogOpen = false;

  function zoomOutMobile() {
    zoomDialog.trigger('destroy');
    $('.fc-zoom-mobile-container').hide().attr('aria-hidden', true);
    $container.find('.fc-wrapper').attr('aria-hidden', false);
    $('.fc-zoom-button')[0].focus();
    dialogOpen = false;
  }

  document.addEventListener('focus', function(event) {
    const dialog = $container.find('.fc-zoom-mobile-container')[0];

    if ( dialogOpen && !dialog.contains(event.target) ) {
      event.stopPropagation();
      dialog.focus();
    }
  });

  document.addEventListener('keydown', function(event) {
    if ( dialogOpen && event.keyCode === 27 ) {
      zoomOutMobile();
    }
  });


  function zoomOut() {
    // Hide the zoom container and destroy the zoom plugin
    if(zoomComponent !== undefined) {
      zoomComponent.trigger('destroy');
      zoomComponent = undefined;
      $container.find('.fc-zoom-container').trigger('zoom.destroy').hide();
      dialogOpen = false;
    }
  }
  function loadZoomImage(view, doZoom) {
    // Create an image in the zoom container
    configure.run('createComponent', {
      type: 'recipeImage',
      view,
      width: 1200,
      container: '.fc-zoom-container',
      format: 'jpg',
      quality: 91
    }, function(err, zoom) {
      if (err) { throw err; }

      // Make the image component accessible
      zoomComponent = zoom;

      zoomComponent.on('image:loaded', function () {
        // we use doZoom = true when we zoom
        // or doZoom = false when we just want to refresh the images
        if(doZoom) {
          // check if we are still over on model div,
          // if true then we launch the zoom,
          // if false then we destroy zoom component.
          // This is only to deal with the delay on the load of zoom image,
          // or when we change an option and quickly leave the model
          if (document.querySelector('.fc-zoom-hover-trigger:hover') !== null) {
            $container.find('.fc-zoom-container').show().zoom();
          } else {
            zoomOut();
          }
        }
      });
    });
  }

  function zoomIn() {
    // Show the zoom contianer and define the zoom plugin
    loadZoomImage(app.store.currentView(), true);
    $( '.fc-zoom-container .fc-display').prepend( '<div class="fc-zoom-white-layer" style="background-color: white;"></div>' );
    dialogOpen = true;
  }

  function updateZoomImage(forceUpdate) {
    // If the defined image view and current view don't match
    // or if we force an update with recipe:change
    if ( !_.isUndefined(zoomComponent) && (imageView !== app.store.currentView() || forceUpdate) ) {
      // Destroy the recipeImage component
      zoomOut();
      // Sync up the current view with the defined view
      imageView = app.store.currentView();
      // Load the new image
      loadZoomImage(imageView, false);
    }
  }

  function zoomInMobile() {
    const options = {
      container: '.fc-main-panel-zoom',
      type: 'recipeImage',
      view: app.store.currentView(),
      backgroundColor: app.backgroundColor
    };
    configure.run('createComponent', options,
      function (err) {
        if (err) { throw err; }
      });
  }

  function hideZoomMobile(zoomDialog) {
    zoomDialog.trigger('destroy');
    $container.find('.fc-wrapper').attr('aria-hidden', false);
    $('.fc-zoom-mobile-container').show().attr('aria-hidden', true);
    $container.find('.fc-zoom-button').find('.fc-button-pair')[0].focus();
    $('.fc-zoom-mobile-container').hide();
  }

  function dialogZoomMobile() {
    const closeAriaLabel = app.l10n.getLang('close_zoom_aria_label', 'Close');
    const options = {
      type: 'html',
      container: '.fc-zoom-mobile-container',
      innerHTML: '<div class="fc-zoom-alert"><span role="button" aria-label="' + closeAriaLabel + '" style="position:absolute; right:20px; top:20px; z-index: 999;" class="fc-icon-close close-dialog fc-zoom-dialog-close" tabindex="0"></span><div class="fc-main-panel-zoom"> </div></div>'
    };
    configure.run('createComponent', options, function (err, ZoomDialog) {
      if (err) { throw err; }

      zoomDialog = ZoomDialog;
      dialogOpen = true;

      zoomInMobile();

      $('.fc-zoom-dialog-close').on('click', function() {
        hideZoomMobile(zoomDialog);
      });

      $container.find('.fc-wrapper').attr('aria-hidden', true);

      $('.fc-zoom-mobile-container').show().attr('aria-hidden', false);
      $container.find('.fc-zoom-dialog-close').on('keypress', function(e) {
        if ( e.keyCode === 13 ) {
          hideZoomMobile(zoomDialog);
        }
      })[0].focus();

      const image = $('.fc-main-panel-zoom').find('img')[0];
      app.pinch_and_zoom.init(image);
    });
  }

  function init() {
    // Cache our selectors
    const $model = $container.find('.fc-zoom-hover-trigger'),
      $zoom = $container.find('.fc-zoom-container');
    let timer;

    // When we hover over the model we want to show the
    // zoom image
    $model
      .off('mouseenter.fc-zoom')
      .on('mouseenter.fc-zoom', function() {
        // Wrap a setTimeout on this because the model container is wider
        // that the zoom container. You can mouse off the zoom container
        // and mouse over the model container in the same motion so the zoom
        // dialog is triggered twice
        timer = setTimeout(function() {
          zoomIn();
        }, 100);
      });

    $model
      .off('mouseleave.fc-zoom-leave')
      .on('mouseleave.fc-zoom-leave', function() {
        clearTimeout(timer);
      });

    // Since the model is now covered we bind the mouseleave
    // events to the zoom container
    $zoom
      .off('mouseleave.fc-zoom')
      .on('mouseleave.fc-zoom', zoomOut);

    // Listen to changes from the store
    app.store.subscribe(function() {
      if ( app.store.refreshUI() ) {
        // Update the zoom image if the refreshUI
        // has beentriggered
        updateZoomImage();
      }
    });
    // Ensure the zoom never gets stuck
    window.setInterval(function() {
      if (dialogOpen) {
        if (!$container[0].querySelector('.fc-zoom-hover-trigger:hover') &&
          !$container[0].querySelector('.fc-zoom-container:hover')) {
          zoomOut();
        }
      }
    }, 500);
  }

  function initMobile() {
    let options = {};

    options = {
      type: 'button',
      title: 'ZOOM',
      container: '.fc-zoom-button',
      tabIndex: 0,
      onClick() {
        dialogZoomMobile();
      }
    };
    const _callback = function(err) {
      if (err) { throw err; }
      $container.find('.fc-zoom-button').on('keypress', function(e) {
        if ( e.keyCode === 13 ) {
          dialogZoomMobile();
        }
      });
      // Set recipe image size for zoom dialog
      configure.run('setComponentOptions', {
        'recipeImage': {
          width: 500,
          format: 'jpg',
          quality: 90
        }
      });

      $container.find('.fc-zoom-button').on('keypress', function(e) {
        if ( e.keyCode === 13 ) {
          dialogZoomMobile();
        }
      });
    };

    configure.run('createComponent', options, _callback);
  }

  /**
   *  Expose Public Properties/Methods
   */
  return {
    init,
    updateZoomImage,
    zoomOut,
    initMobile
  };
};

module.exports = Zoom;
